import _ from "lodash";
import { CLIENTS, currentClient } from "../../../config/clientConfig";

// Sportdigital shows every template for 30s. Set here rather than in each
// caller's fallback, because the timeline player and every template's
// animation (progress bar included) each ask this function for the duration
// with a different fallback -- the player its config default, the animations
// 0 -- so only a value set here keeps the slide and its animation the same
// length. A time set in Setup (per competition or per template) still wins.
const SD_TEMPLATE_DURATION = 30;

export const getTemplateDurationOveride = ({
  apiSetup,
  tournamentId,
  fallback,
  templateName = "",
  event
}) => {
  const feedType = event?.feedType || 'opta'
  let templateDuration =
    currentClient === CLIENTS.SD && !["staticmedia", "staticslide"].includes(templateName)
      ? SD_TEMPLATE_DURATION
      : fallback;
  const templateTimeOverride =
    apiSetup?.timeline?.settings?.timings?.[tournamentId];
  let templateTypeTimeOverride =
    apiSetup?.timeline?.settings?.templatesTimings?.[templateName];

  if(feedType === 'heimspiel') {
    templateTypeTimeOverride = apiSetup?.timeline?.settings?.templatesTimings?.heimspiel?.[templateName] || '15';
  }

  if (templateTimeOverride) {
    if (!["staticmedia", "staticslide"].includes(templateName)) {
      const parsed = parseInt(templateTimeOverride) + 1;
      templateDuration = _.isNaN(parsed) ? fallback : parsed;
    }
  }

  if (templateTypeTimeOverride) {
    if (!["staticmedia", "staticslide"].includes(templateName)) {
      const parsed = parseInt(templateTypeTimeOverride) + 1;
      templateDuration = _.isNaN(parsed) ? fallback : parsed;
    }
  }

  return templateDuration;
};
